module.exports = __webpack_public_path__ + "img/head4.bc73301c.png";